<template>
  <section class="share">
    <h2 v-if="label" class="share__label">{{ label }}</h2>
    <ul class="share__links">
      <li class="share__item">
        <a :href="networkUrls.facebook" aria-label="Share on facebook" @click.prevent="openSocialWindow('facebook')"><FacebookShare /></a>
      </li>
      <li class="share__item">
        <a :href="networkUrls.twitter" aria-label="Share on twitter" @click.prevent="openSocialWindow('twitter')"><Twitter /></a>
      </li>
      <li class="share__item">
        <a :href="mailtoUrl" aria-label="Share by email"><Envelop /></a>
      </li>
    </ul>
  </section>
</template>

<script>
import Envelop from '~/assets/icons/envelop.svg?inline';
import Twitter from '~/assets/icons/twitter.svg?inline';
import FacebookShare from '~/assets/icons/facebook-share.svg?inline';

export default {
  components: {
    Envelop,
    Twitter,
    FacebookShare,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    windowParams: {
      type: Object,
      default() {
        return {
          facebook: { width: 600, height: 300 },
          twitter: { width: 600, height: 254 },
        };
      },
    },
    twiterAccount: { type: String, default: 'collective_llp' },
    devUrl: { type: String, default: 'http://localhost:3000' },
    fallbackUrl: { type: String, default: 'https://www.thecollective.com/co-living/old-oak' },
  },
  computed: {
    networkUrls() {
      return {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.url}&t=${this.title}`,
        twitter: `https://twitter.com/share?url=${this.url}&text=${this.title}&via=${this.twiterAccount}`,
      };
    },
    mailtoUrl() {
      return `mailto:?subject=Check out this article from The Collective Journal&body=${this.title} - ${this.url}`;
    },
    url() {
      const windowHref = window.location.href;

      if (windowHref.includes(this.devUrl)) {
        return encodeURI(this.fallbackUrl);
      }

      return encodeURI(windowHref);
    },
  },
  methods: {
    openSocialWindow(network) {
      const options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
      const windowObj = this.windowParams[network];
      const href = this.networkUrls[network];

      if (windowObj && href.length > 0) {
        window.open(href, '', `${options}height=${windowObj.height},width=${windowObj.width}`);
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_share.scss';
</style>
